/**
 * This file contains our theme helpers for the formkit inputs.
 */

export const basicTagsList = {
  "family:tags__label": {
    block: true,
    "mb-1": true,
    "font-bold": true,
    "text-sm": true,
    "formkit-invalid:text-error": true,
  },
  "family:tags__inner": {
    "formkit-invalid:border-error": true,
    "mb-1": true,
  },
  "family:tags__input": {
    "w-full": true,
    "h-10": true,
    "px-3": true,
    border: true,
    "border-gray-400": true,
    "text-base": true,
    "text-gray-900": true,
    "placeholder-gray-400": true,
    "focus-within:border-indigo-500": true,
    "rounded-lg": true,
  },
  "family:tags__chip": {
    border: true,
    "border-gray-400": true,
    rounded: true,
    "bg-indigo-100": true,
    "text-indigo-700": true,
  },
};

export const formCustomStyles = {
  flex: true,
  "flex-col": true,
  "gap-x-4": true,
};

export const submitOuterCustomStyles = {
  "max-w-[24em]": false,
};

export const submitWrapperCustomStyles = {
  flex: true,
  "justify-end": true,
};

export const taglistTagLabelCustomStyles = {
  "pl-0.5": true,
};

export const errorInputCustomStyles = {
  "group-data-[errors]:border-red-400": true,
  "group-data-[errors]:ring-1": true,
  "group-data-[errors]:ring-red-400": true,
};

export const selectOptionCustomStyles = {
  "text-black": true,
};
